import React, {useState} from 'react';

import Header from "../../../layouts/Header";
import Navbar from "../../../layouts/Navbar";
import {useNavigate} from "react-router-dom";
import {CiCalendarDate, CiLocationOn} from "react-icons/ci";
import {HiHashtag} from "react-icons/hi";
import {getOrders, getStatuses} from "../api/OrdersAPI";
import Loading from "../../../layouts/Loading";
import {showError} from "../../../utils/toastHelper";

const currencyFormat = Intl.NumberFormat('en-US');

function Orders() {
    const navigate = useNavigate();

    const [loading, setLoading] = useState(false);
    const [orders, setOrders] = React.useState([]);
    const [statuses, setStatuses] = React.useState([]);
    const [status, setStatus] = React.useState(null);
    const config = window.APP_CONFIG;

    React.useEffect(() => {


        const fetchOrders = async () => {

            try {
                if (!status) {
                    setLoading(true);
                    const sparams = {
                        count: 40,
                        page: 1,
                        list: 1,
                        orderBy: 'priority_id',
                        orderType: 'asc',
                        category: 'Orders'
                    }
                    const result = await getStatuses(sparams);
                    setStatuses(result.data);
                }
                const params = {
                    count: 40,
                    page: 1,
                    list: 1,
                    orderBy: 'created_at',
                    orderType: 'desc',
                    status_id : status
                }
                const data = await getOrders(params);
                setOrders(data.data);

            } catch (err) {
                 showError( err);
            } finally {
                setLoading(false);
            }
        };
        fetchOrders();
        setTimeout (() => {
            window.scrollTo({top: 0, behavior: 'smooth'});
        },400)

    }, [status]);

    const onSelectStatus = (event, sid,color) => {
        if(sid > 0) {
            const el = document.getElementById('groups-container');
            // el.scrollLeft -= 100;
            el.scrollTo({top: 0, left: el.scrollLeft - 120, behavior: 'smooth'});
        }

        var items = document.getElementsByClassName('product-group-badge');

        for (var i = 0; i < items.length; i++) {
            items[i].style.backgroundColor = '#aaa';
        }

        event.target.style.backgroundColor = color
        setStatus(sid)
    }

    if (loading) return <Loading />;

    return (
        <React.Fragment>

            <Header title='تاریخچه سفارش ها' hasBack={false} />

            <section className="container  mt-3 py-5 rtl px-0   ">

                <div className="row  flex-row flex-nowrap mx-2 overflow-scroll product-group-row border-bottom pb-4"
                     id='groups-container'
                >
                    <div className="col-3 badge badge-pill mx-2 product-group-badge "
                         style={{backgroundColor: '#424242'}}
                         onClick={
                             (e) => {
                                 onSelectStatus(e, null, '#424242');

                             }
                         }
                    >
                        همه
                    </div>
                    {
                        !loading && statuses.map(status => {
                                return (
                                    <div className="col-3 badge badge-pill mx-2 product-group-badge " key={status.id}

                                         onClick={
                                             (e) => {
                                                 onSelectStatus(e, status?.id, status?.color);

                                             }
                                         }
                                    >
                                        {status.title}
                                    </div>
                                );
                            }
                        )
                    }
                </div>


                <div className="row mx-2 mb-3">
                    {
                        orders.map (order => {
                            return (
                                <div className="col-12 rtl mt-3 order-row py-3 "
                                     key={order.id}
                                     onClick={() => navigate(`/orders/${order.id}`)}
                                >
                                    <div className="row py-2 ">

                                        <div className="col-9 fw-bold text-small-1 text-muted border-bottom pb-3">

                                            {order?.address ?
                                                <div className='fw-bold mt-2'>
                                                    <CiLocationOn className='ms-1'/>
                                                    {order?.address?.title}
                                                    :
                                                    &nbsp;
                                                    {order.address?.address}
                                                </div>
                                                :
                                                <div className='fw-bold mt-2'>
                                                    <CiLocationOn className='ms-1'/>
                                                   مراجعه حضوری
                                                    :
                                                    &nbsp;
                                                    {config.address}
                                                </div>
                                            }

                                        </div>
                                        <div className="col-3 text-start border-bottom pb-3">
                                            <div className='text-small-2 bg-success bg-opacity-10 text-center rounded '>
                                                <HiHashtag className='mx-1'/>
                                                {order.tracking_code}
                                            </div>
                                            <div className=' mt-3 text-center rounded bg-secondary text-small-3  bg-opacity-10' style={{color: order.last_status.color}}>
                                                {order?.last_status.title}
                                            </div>

                                        </div>
                                        <div className="col-6">
                                            <div className='fw-normal text-small-3 mt-2 text-muted'>
                                                <CiCalendarDate className='ms-1' />
                                                {order.date}
                                            </div>
                                        </div>
                                        <div className="col-6 text-start text-secondary mt-2 text-small-1 fw-bolder">
                                            {
                                                order.cash_discount_percent > 0 ?
                                                    currencyFormat.format(order.pay_amount * ( 1 - (order.cash_discount_percent / 100)))
                                                    :
                                                    currencyFormat.format(order.pay_amount)
                                            }

                                            &nbsp;
                                            ریال
                                        </div>
                                    </div>
                                </div>
                            )} )
                    }
                </div>

            </section>
            <Navbar />
        </React.Fragment>
    );
}

export default Orders;